(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('AlumnoUadyMatriculado', AlumnoUadyMatriculado);

    AlumnoUadyMatriculado.$inject = ['$resource'];

    function AlumnoUadyMatriculado ($resource) {
        var resourceUrl =  'api/alumno-uady-matriculados/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'getActiveByProgramaEducativo': { 
            	method: 'GET', 
            	isArray: true,
            	url:'api/alumno-uady-matriculados/search/:programaEducativo,:search',
            },
            'getActiveByCGSE': { 
            	method: 'GET', 
            	isArray: true,
            	url:'api/alumno-uady-matriculados/searchAll/:cgse,:search',
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
